import { create } from 'zustand';
import { chatsApi } from '@/shared/api/messenger';

interface MessengerUnreadState {
  unread: number;
  activeChatId: string | null;
  refresh: () => Promise<void>;
  reset: () => void;
  setActiveChat: (chatId: string | null) => void;
}

let lastRequest = 0;

export const useMessengerUnreadStore = create<MessengerUnreadState>((set) => ({
  unread: 0,
  activeChatId: null,
  refresh: async () => {
    const request = ++lastRequest;
    try {
      const unread = await chatsApi.unread();
      if (request === lastRequest) set({ unread });
    } catch {
    }
  },
  reset: () => set({ unread: 0, activeChatId: null }),
  setActiveChat: (chatId) => set({ activeChatId: chatId }),
}));
